export const SET_EVENT_DATA =   'SET_EVENT_DATA';
export const SET_EVENT_HALL =   'SET_EVENT_HALL';
export const SET_LIVE_PRESENTATION = 'SET_LIVE_PRESENTATION';
export const SET_PANEL_DISCUSSION = 'SET_PANEL_DISCUSSION';
export const SET_ON_DEMAND = 'SET_ON_DEMAND';
export const SET_ROUND_TABLE='SET_ROUND_TABLE';
export const SET_BOOTH='SET_BOOTH';
export const SET_SPEAKERS = 'SET_SPEAKERS';



